import { useEffect } from 'react';
import { Navbar } from '../components/Navbar';
import { Phone } from 'lucide-react';

export const TentangPage = () => {
  // Set page title
  useEffect(() => {
    document.title = 'Tentang Park Serpong - Kawasan Kota Mandiri 400 Hektar | Lippo Karawaci';
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar scrolled={true} currentPage="tentang" />

      {/* Hero */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden mt-16 md:mt-20">
        <img
          src="/images/beranda/park_serpong.jpeg"
          alt="Park Serpong"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black/70"></div>
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 drop-shadow-2xl">Tentang Park Serpong</h1>
          <p className="text-xl md:text-2xl drop-shadow-lg">Kawasan Kota Mandiri #LebihMasukAkal</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Park Serpong: Kota Mandiri Terpadu</h2>
            <p className="text-lg text-gray-700 mb-6 text-justify leading-relaxed">
              Park Serpong adalah kawasan kota mandiri seluas <strong>400 hektar</strong> yang sedang dikembangkan di <strong>Jl. Raya Legok, Tangerang, Banten</strong>. Dikembangkan oleh <strong>Lippo Karawaci / LippoLand</strong>, developer terpercaya dengan pengalaman 40+ tahun di industri properti Indonesia.
            </p>
            <p className="text-lg text-gray-700 mb-8 text-justify leading-relaxed">
              Konsep kota mandiri menghadirkan kombinasi sempurna antara hunian residensial, area komersial (ruko & office), fasilitas publik lengkap, dan infrastruktur modern dalam satu kawasan terintegrasi.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-6">Master Plan 400 Hektar</h2>
            <div className="grid md:grid-cols-2 gap-6 mb-12">
              <div className="bg-white rounded-xl p-6 shadow-lg border-l-4 border-blue-600">
                <h3 className="text-xl font-bold text-gray-900 mb-3">🏠 Zona Residensial (60%)</h3>
                <ul className="space-y-2 text-gray-700">
                  <li>• 6 Fase pengembangan (Phase 1-6)</li>
                  <li>• 60+ tipe unit rumah (2-3 lantai)</li>
                  <li>• Harga: Rp 299 Juta - 2.3 Miliar</li>
                  <li>• Target: 5,000+ unit hunian</li>
                </ul>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg border-l-4 border-green-600">
                <h3 className="text-xl font-bold text-gray-900 mb-3">🏢 Zona Komersial (15%)</h3>
                <ul className="space-y-2 text-gray-700">
                  <li>• Ruko & shop office</li>
                  <li>• Commercial hub</li>
                  <li>• F&B dan retail area</li>
                  <li>• Co-working space</li>
                </ul>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg border-l-4 border-yellow-600">
                <h3 className="text-xl font-bold text-gray-900 mb-3">🌳 Fasilitas Publik (15%)</h3>
                <ul className="space-y-2 text-gray-700">
                  <li>• Lentera School - Sekolah berkualitas dalam kawasan</li>
                  <li>• Mall & Retail Area - Pusat perbelanjaan modern</li>
                  <li>• University - Akses mudah ke kampus ternama</li>
                  <li>• Rumah Sakit - Fasilitas kesehatan lengkap</li>
                  <li>• Club house & Swimming pool</li>
                  <li>• Jogging track & Taman hijau</li>
                </ul>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg border-l-4 border-red-600">
                <h3 className="text-xl font-bold text-gray-900 mb-3">🚗 Infrastruktur (10%)</h3>
                <ul className="space-y-2 text-gray-700">
                  <li>• Jalan internal lebar 8-12m</li>
                  <li>• Drainage system modern</li>
                  <li>• Underground utilities</li>
                  <li>• Security 24/7 + CCTV</li>
                </ul>
              </div>
            </div>

            <h2 className="text-3xl font-bold text-gray-900 mb-6">Lokasi Strategis</h2>
            <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 text-white mb-12">
              <h3 className="text-2xl font-bold mb-6">Segitiga Emas: Karawaci - Gading - BSD</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <p className="mb-2">✓ <strong>Gading Serpong:</strong> 5 menit</p>
                  <p className="mb-2">✓ <strong>Lippo Karawaci:</strong> 5 menit</p>
                  <p className="mb-2">✓ <strong>Supermall Karawaci:</strong> 5 menit</p>
                </div>
                <div>
                  <p className="mb-2">✓ <strong>BSD City:</strong> 15 menit</p>
                  <p className="mb-2">✓ <strong>Tol Jakarta-Merak:</strong> 10 menit</p>
                  <p className="mb-2">✓ <strong>Stasiun Cicayur:</strong> 15 menit</p>
                </div>
              </div>
            </div>

            <div className="bg-blue-50 rounded-2xl p-8 text-center border-2 border-blue-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Tertarik dengan Park Serpong?</h3>
              <p className="text-lg text-gray-700 mb-6">
                Hubungi tim kami untuk informasi lengkap dan jadwalkan kunjungan
              </p>
              <a
                href="https://wa.me/628892273880?text=Halo!%20Saya%20ingin%20bertanya%20tentang%20Park%20Serpong.%20Terima%20kasih!"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg font-bold transition-all hover:scale-105"
              >
                <Phone size={20} />
                WhatsApp: 08892273880
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};